import SocialSection from './SocialSection'

export default SocialSection
